export default __webpack_public_path__ + "images/industrial-icon.png?bae57c3edf486fc60c2db83e5df9610e";